export const mailboxTypes = [
  {
    key: 'selected',
    title: 'Specific inboxes',
  },
  {
    key: 'all',
    title: 'All inboxes',
  },
]
